module.exports = __webpack_public_path__ + "img/no-approved-job.5c241d79.svg";